export default {
  username: 'Usuario',
  password: 'Contraseña',
  submit: 'Login',
  continue: 'Continuar sin iniciar sesión',
  // error: 'Inicio de sesión o contraseña incorrectos',
  error:
    "C'è un errore oppure l'username o la password sono errati.<br/> La pagina verrà ricaricata tra qualche secondo oppure procedi manualmente.",
}
